import React, { useEffect } from "react";
import {
  Radio,
  Spin,
  PageHeader,
  Button,
  DatePicker,
  message as messageAntd,
} from "antd";
import {
  LoadingOutlined,
  LineChartOutlined,
  LayoutOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import TableDP from "../components/tableDP";
import ChartRG from "../components/chartRG";
import {
  getData,
  change_filter,
  getSelect,
  changeType,
  changeTypeData,
  changeVsMorD,
  getChart,
  changeSelectStatusChart,
} from "../actions/resumenGerencial";
import {
  mesesArrayL as months,
  mesesArrayS as shortMonths,
} from "../helpers/const";

function ResumenGerencial(props) {
  const dispatch = useDispatch();
  const currentDay = Number(moment().format("D"));
  const currentMonth = Number(moment().format("M"));
  const currentYear = Number(moment().format("YYYY"));

  const loading = useSelector((state) => state.resumenGerencial.loading);
  const year = useSelector((state) => state.resumenGerencial.anio);
  const month = useSelector((state) => state.resumenGerencial.mes);
  const type = useSelector((state) => state.resumenGerencial.type);
  const typeData = useSelector((state) => state.resumenGerencial.typeData);
  const vsMorD = useSelector((state) => state.resumenGerencial.vsMorD);
  const data = useSelector((state) => state.resumenGerencial.data);
  const dataChart = useSelector((state) => state.resumenGerencial.dataChart);
  const select = useSelector((state) => state.resumenGerencial.select);
  const selectStatusChart = useSelector(
    (state) => state.resumenGerencial.selectStatusChart
  );

  useEffect(() => {}, []);

  function onChangeSelectStatusChart(type, select, value) {
    dispatch(changeSelectStatusChart(type, select, value));
  }

  function loadDataChart(type) {
    console.log(type);
    if (
      selectStatusChart[type].idIndicator != null &&
      selectStatusChart[type].idBrand != null &&
      selectStatusChart[type].year != null
    ) {
      dispatch(
        getChart(
          type,
          selectStatusChart[type].idIndicator,
          selectStatusChart[type].idBrand,
          selectStatusChart[type].year
        )
      );
      localStorage.setItem(
        "selectStatusChartV3",
        JSON.stringify(selectStatusChart)
      );
    } else {
      messageAntd.warning("Todos los campos son necesarios");
    }
  }

  function onChangeData() {
    if (month != 0 && year != 0) {
      dispatch(getData(year, month, type, vsMorD));
    } else {
      messageAntd.warning("Seleccina una fecha válida");
    }
  }

  function onChangeDate(date, dateString) {
    dispatch(
      change_filter(Number(date.format("YYYY")), Number(date.format("M")))
    );
  }

  function onChangeTypeData(e) {
    if (e.target.value === 1) {
      if (!select.new) {
        dispatch(getSelect());
      }
    }
    dispatch(changeTypeData(e.target.value));
  }

  function onChangeType(e) {
    dispatch(changeType(e.target.value));
  }

  function onChangeVsMorD(e) {
    dispatch(changeVsMorD(e.target.value));
  }

  return (
    <div style={{ margin: "18px" }}>
      <Spin spinning={loading}>
        <PageHeader
          className="m-page-header"
          style={{ paddingBottom: "20px" }}
          onBack={null}
          title={
            <div style={{ fontSize: "18px" }}>
              Resumen Gerencial | Grupo Optima{" "}
            </div>
          }
          subTitle={null}
          extra={[
            typeData === 0 &&
            currentMonth === month &&
            currentYear === year &&
            Object.keys(data).length !== 0 ? (
              <Radio.Group key={0} value={vsMorD} onChange={onChangeVsMorD}>
                <Radio.Button value={1}>vs. Día actual</Radio.Button>
                <Radio.Button value={0}>vs. Mes</Radio.Button>
              </Radio.Group>
            ) : null,
            typeData === 0 && Object.keys(data).length !== 0 ? (
              <Radio.Group key={1} value={type} onChange={onChangeType}>
                <Radio.Button value={2}>
                  vs. Presupuesto {months[month]} {year}
                </Radio.Button>
                <Radio.Button value={1}>
                  vs.{" "}
                  {months[month - 1] !== "Unknow"
                    ? months[month - 1]
                    : months[12]}{" "}
                  {months[month - 1] !== "Unknow" ? year : year - 1}
                </Radio.Button>
                <Radio.Button value={0}>
                  vs. {months[month]} {year - 1}
                </Radio.Button>
              </Radio.Group>
            ) : null,
            <Radio.Group key={2} value={typeData} onChange={onChangeTypeData}>
              <Radio.Button value={0}>
                <LayoutOutlined />
              </Radio.Button>
              <Radio.Button value={1}>
                <LineChartOutlined />
              </Radio.Button>
            </Radio.Group>,
            typeData === 0 ? (
              <DatePicker
                key={3}
                onChange={onChangeDate}
                placeholder="Fecha"
                style={{ width: 120, marginRight: "8px" }}
                picker={typeData === 0 ? "month" : "year"}
              />
            ) : null,
            typeData === 0 ? (
              <Button key={4} type="primary" onClick={onChangeData}>
                Consultar
              </Button>
            ) : null,
          ]}
        />

        <div className="dp-table-container">
          {typeData === 0 ? (
            <TableDP
              vsMorD={vsMorD}
              date={`${
                currentMonth === month && currentYear === year
                  ? currentDay + "/"
                  : ""
              }${shortMonths[month]}/${year}`}
              data={data.result ? data.result : []}
              headers={data.headers ? data.headers : []}
            />
          ) : (
            <ChartRG
              select={select}
              selectStatusChart={selectStatusChart}
              onChangeSelectStatusChart={onChangeSelectStatusChart}
              dataChart={dataChart}
              loadData={loadDataChart}
            />
          )}
        </div>
      </Spin>
    </div>
  );
}

export default ResumenGerencial;
